// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from '../common/Modal';
import ImportSourcesModalUploader from './ImportSourcesModalUploader';
import TemplateDownloader from './TemplateDownloader';


class ImportSourcesModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTemplateDownloader: false
    };

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleOpenTemplateDownloader = this.handleOpenTemplateDownloader.bind(this);
    this.handleDownloadTemplates = this.handleDownloadTemplates.bind(this);
  }

  handleOpenTemplateDownloader() {
    this.setState({ showTemplateDownloader: true });
  }

  handleDownloadTemplates(settings) {
    const { onDownloadTemplates } = this.props;
    this.setState({ showTemplateDownloader: false });
    return onDownloadTemplates(settings);
  }

  handleDismiss() {
    this.setState({ showTemplateDownloader: false });
    this.props.onDismiss();
  }

  renderContent() {
    if (this.state.showTemplateDownloader) {
      return (
        <div className='import-sources-modal__template-downloader-container'>
          <h2>Download Template Files</h2>
          <TemplateDownloader
            onCancel={this.handleDismiss}
            onSubmit={this.handleDownloadTemplates}
            dsaType={this.props.dsaType}
          />
        </div>
      );
    }

    const { onSubmitImport, importResults, importErrors, importing } = this.props;

    return (
      <ImportSourcesModalUploader
        onClickCancel={this.handleDismiss}
        onClickDownloadTemplates={this.handleOpenTemplateDownloader}
        onSubmit={onSubmitImport}
        importResults={importResults}
        importErrors={importErrors}
        importing={importing}
      />
    );
  }

  render() {
    const { open } = this.props;

    return (
      <Modal
        className='import-sources-modal'
        open={open}
        onDismiss={this.handleDismiss}
      >
        {this.renderContent()}
      </Modal>
    );
  }
}

ImportSourcesModal.defaultProps = {
  open: false
};

ImportSourcesModal.propTypes = {
  dsaType: PropTypes.string,
  open: PropTypes.bool,
  onDismiss: PropTypes.func,
  onSubmitImport: PropTypes.func.isRequired,
  onDownloadTemplates: PropTypes.func.isRequired,
  importResults: PropTypes.object.isRequired,
  importErrors: PropTypes.array.isRequired,
  importing: PropTypes.bool.isRequired
};

export default ImportSourcesModal;



// WEBPACK FOOTER //
// ./src/components/sources/ImportSourcesModal.js